module.exports = __webpack_public_path__ + "img/jian02.dbc3b644.png";